module.exports = __webpack_public_path__ + "static/media/10.89106f74.jpg";